<template>
  <div
    class="container p-3.5 lg:px-16 xl:px-16 mx-auto mt-2 relative"
    v-motion
    :initial="{ opacity: 0, x: -50, scale: 0.9 }"
    :enter="{ opacity: 1, x: 0, scale: 1 }"
    :hover="{ scale: 1.05, rotateY: 10 }"
    transition="{ stiffness: 50, damping: 15 }"
  >
    <!-- Mobile: Single card with auto-scrolling -->
    <div v-if="isMobile" class="swiper-container">
      <swiper
        :slides-per-view="1.5"
        :space-between="16"
        :centeredSlides="true"
        :modules="modules"
        class="mySwiperActivity"
      >
        <swiper-slide v-for="(activity, index) in activities" :key="index">
          <ActivityElement :activity="activity" />
        </swiper-slide>
      </swiper>
    </div>
    <div v-else-if="isTablet" class="swiper-container">
      <swiper
        :slides-per-view="1.5"
        :space-between="16"
        :centeredSlides="true"
        :modules="modules"
        class="mySwiperActivity"
      >
        <swiper-slide v-for="(activity, index) in activities" :key="index">
          <ActivityElement :activity="activity" />
        </swiper-slide>
      </swiper>
    </div>
    <!-- Tablet and Desktop: Multiple cards with navigation -->
    <div v-else>
      <swiper
        :spaceBetween="10"
        :modules="modules"
        :slides-per-view="3.5"
        :space-between="16"
        class="mySwiperActivity"
      >
        <swiper-slide v-for="(activity, index) in activities" :key="index">
          <ActivityElement :activity="activity" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- "See All" link -->
    <RouterLink
      :to="'/activities'"
      v-if="showAll"
      class="text-blue underline font-bold text-sm flex justify-center mt-4"
    >
      {{ $t('seeAll') }}
    </RouterLink>
  </div>
</template>

<script>
import ActivityElement from './ActivityElement.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation'; // Import styles for navigation
import { Navigation, Autoplay } from 'swiper/modules';

export default {
  components: {
    ActivityElement,
    Swiper,
    SwiperSlide,
  },
  props: {
    activities: {
      type: Array,
      required: true,
    },
    showAll: {
      type: Boolean,
      default: true,
    },
    notShowing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  setup() {
    return {
      modules: [Navigation, Autoplay],
    };
  },
  methods: {
    handleResize() {
      const width = window.innerWidth;
      this.isMobile = width <= 600; // Mobile: <= 768px
      this.isTablet = width > 600 && width <= 1024; // Tablet: 769px - 1024px
    },
  },
  async mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.mySwiperActivity {
  width: 100%;
  padding: 8px;
  height: 21rem;
}

@media (max-width: 1024px) {
  .mySwiperActivity {
    height: 19rem;
  }
}

.custom-prevActivity,
.custom-nextActivity {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  color: #fff; /* White icon color */
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  cursor: pointer;
}

.custom-prevActivity {
  left: 5px;
}

.custom-nextActivity {
  right: 5px;
}

.custom-prevActivity i,
.custom-nextActivity i {
  font-size: 16px;
}

@media (min-width: 1024px) {
  .custom-prevActivity {
    left: 0px;
  }
  .custom-nextActivity {
    right: 0px;
  }
}
</style>